
interface PixelDetailsProps {
  details: any;
  websiteCheckResult: any;
}

export function PixelDetails({ details, websiteCheckResult }: PixelDetailsProps) {
  if (!details) return null;
  
  return (
    <div className="bg-slate-50 p-4 rounded-lg">
      <h4 className="text-sm font-medium mb-2">Pixel Details</h4>
      <div className="space-y-2">
        <div className="flex justify-between">
          <span className="text-sm text-slate-500">Name:</span>
          <span className="text-sm font-medium">{details?.pixelName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-slate-500">Domain:</span>
          <span className="text-sm font-medium">{details?.pixelDomain}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-slate-500">Validated:</span>
          <span className="text-sm font-medium">{new Date(details?.testTime).toLocaleString()}</span>
        </div>
        {websiteCheckResult?.url && (
        <div className="flex justify-between">
          <span className="text-sm text-slate-500">Checked URL:</span>
          <span className="text-sm font-medium">{websiteCheckResult.url}</span>
        </div>
        )}
      </div>
    </div>
  );
}
